import Constants from '@/Constants';
import React, { MouseEventHandler, useEffect, useState } from 'react';
import Modal from 'react-bootstrap/esm/Modal';
import ActionFeedbackModalBody, { ButtonStyle } from './ActionFeedbackModalBody';
import './style.scss';

interface Props {
    success: boolean;
    error: boolean;
    successMessage: string;
    errorMessage: string;
    onRetry?: MouseEventHandler;
    loading: boolean;
    id?: string;
    onHide?: CallableFunction;
    title?: string;
}

const ActionFeedBackModal: React.FC<Props> = (props: Props) => {
    const { success, error, successMessage, errorMessage, loading, id, onRetry, onHide } = props;
    const [showModal, setShowModal] = useState<boolean>(success || error);

    useEffect(() => {
        setShowModal(success || error);
    }, [success, error]);

    useEffect(() => {
        if (!showModal && onHide) {
            setTimeout(() => onHide(), 1500);
        }
    }, [showModal]);

    useEffect(() => {
        if (showModal && successMessage && !error && !loading) {
            setTimeout(() => setShowModal(false), 1500);
        }
    }, [showModal, successMessage, error, loading]);

    const errorButtonStyle = onRetry ? ButtonStyle.ActionButtonStyle : ButtonStyle.NoButtonStyle;

    const modalId = id || 'feedback-msg-modal';

    return (
        <Modal backdrop={true} centered dialogClassName="action-feedback-modal" id={modalId} onHide={() => setShowModal(false)} show={showModal}>
            <ActionFeedbackModalBody
                buttonStyle={success ? ButtonStyle.NoButtonStyle : errorButtonStyle}
                icon={success ? Constants.icons.CHECK_CIRCLE : Constants.icons.REPORT_PROBLEM}
                message={success ? successMessage : errorMessage}
                modalId={modalId}
                onCloseModal={() => setShowModal(false)}
                onRetry={onRetry}
                success={success}
                title={props.title}
            />
        </Modal>
    );
};

export default ActionFeedBackModal;
